module.exports = __webpack_public_path__ + "static/media/selec-nft-7.dd084102.png";